import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock, EditableText } from "eddev/blocks"
import { ResponsiveImageFragment } from "@generated-types"
import { ImageCaption } from "@components/atoms/ImageCaption"
import { GallerySlider } from "@components/media/GallerySlider"
import { Slider } from "@components/atoms/Slider"

export const meta: BlockMeta = {
  title: "Image Gallery",
  category: "media",
  keywords: ["gallery", "photo", "picture"],
  description: "One or more images",
  icon: "format-image",
  tags: ["#subpage"],
  editMode: "both",
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("content/gallery", (props) => {
  const images = (props.images?.filter((image) => image?.mediaItemUrl) as ResponsiveImageFragment[]) ?? []
  if (!images?.length) {
    if (env.admin) {
      return <AdminMessage className="w-grid mx-auto my-4">No images selected</AdminMessage>
    }
    return null
  }

  if (props.type === "carousel") {
    return (
      <div className="my-8 relative">
        <GallerySlider
          gridInsert
          scrollerClass="flex gap-grid-gutter px-grid-margin-full"
          images={props.images as ResponsiveImageFragment[]}
          enableCaptions={props.showCaptions ?? false}
        />
      </div>
    )
  } else {
    // Grid layout
    const layoutClasses = GRID_LAYOUTS[props.layout ?? "mixed-1"] || GRID_LAYOUTS.double
    return (
      <div className="md:grid-auto md:gap-y-grid-gutter my-8">
        {images.map((image, i) => (
          <div key={i} className={"mb-3 md:mb-3-0 " + layoutClasses[i % layoutClasses.length]}>
            <ResponsiveImage {...image} />
            <EditableText
              as={ImageCaption}
              store={`caption.${image.mediaItemUrl}`}
              placeholder="Enter an optional caption"
              defaultValue={image.caption!}
            />
          </div>
        ))}
      </div>
    )
  }
})

const GRID_LAYOUTS = {
  double: ["md:col-span-6"],
  "mixed-1": ["md:col-span-8", "md:col-span-4", "md:col-span-6", "md:col-span-6", "md:col-span-4", "md:col-span-8"],
  "mixed-2": ["md:col-span-4", "md:col-span-8", "md:col-span-8", "md:col-span-4", "md:col-span-6", "md:col-span-6"],
  "mixed-3": ["md:col-span-6", "md:col-span-6", "md:col-span-4", "md:col-span-8", "md:col-span-8", "md:col-span-4"],
} as Record<string, string[]>
